import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { useVModel } from '@vueuse/core'
import { PersonalDataCheckboxVariant } from '~/core/components/RulesAgree/types'
import useLocaleStore from '~/stores/useLocaleStore'

type Props = {
  value: boolean,
  error?: boolean,
  variant: PersonalDataCheckboxVariant
}

type Emits = {
  (e: 'input', value: boolean): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalDataCheckbox',
  props: {
    value: { type: Boolean },
    error: { type: Boolean },
    variant: null
  },
  emits: ["input"],
  setup(__props: any) {

const props = __props as {
  value: boolean,
  error?: boolean,
  variant: PersonalDataCheckboxVariant
};

const {
  landingUrl,
  personalDataAgreementLink,
  personalDataReceivingLink,
  thirdPartyPersonalDataAgreementLink,
} = storeToRefs(useLocaleStore())




const data = useVModel(props)

return { __sfc: true,landingUrl, personalDataAgreementLink, personalDataReceivingLink, thirdPartyPersonalDataAgreementLink, props, data, PersonalDataCheckboxVariant }
}

})